import React from 'react';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

const useStyle = makeStyles({
  box: {
    width: '100%',
    height: 220,
  },
  background: {
    background: `url(${
      process.env.PUBLIC_URL + '/icons/background-public.svg'
    })`,
    backgroundSize: 'cover',
    borderRadius: 4,
    height: '100%',
  },
});

export const AvatarBackground = () => {
  const classes = useStyle();

  return (
    <Box className={classes.box}>
      <Box boxShadow={3} className={classes.background} />
    </Box>
  );
};
